import type { Insight } from "schemas/generated/insights";

export const FAKE_INSIGHT: Insight = {
  id: crypto.randomUUID(),
  title: "Increased Engagement on Homepage",
  analysis:
    "Your homepage has shown a 25% increase in user engagement over the past week, particularly in the hero section.",
  action:
    "Consider A/B testing different hero section layouts to further optimize engagement.",
  actionTitle: "Create A/B Test",
  actionPrompt: "Would you like to start an A/B test for your hero section?",
  actionType: "buildInEditor",
  sentiment: "positive",
  reference: "homepage-hero-section",
  url: "https://www.google.com/some-page",
  elementId: "hero-section-container",
  projectId: null,
};
